module.exports = __webpack_public_path__ + "img/my-message.d17b02ac.png";